module.exports = __webpack_public_path__ + "img/right-arrow.bb8a6b71.png";